import { Customer, ExtractFriendlyName } from "src/model/Customer";
import { EditableHorseForSalePurchase } from "./CheckoutTemplate";

const IsWinnerBidderAnAgentAuthorizationForThisPurchaser = (horseSaleId: number, winningBidder: Customer, purchaser: Customer) => {
    const winnerBidderId = winningBidder.id;
    return !!(
        purchaser.id !== winnerBidderId &&
        purchaser.delegatorAuthorizations.find(aa => aa.agent.id === winnerBidderId && aa.sale.id === horseSaleId && aa.dateRevoked === null)
    );
};

export const SortFn = (winningBidder: Customer, horseSaleId: number) => (
    a: EditableHorseForSalePurchase.PurchaseFields,
    b: EditableHorseForSalePurchase.PurchaseFields
) => {
    const hasAgentAuthA = IsWinnerBidderAnAgentAuthorizationForThisPurchaser(horseSaleId, winningBidder, a.purchaser!);
    const hasAgentAuthB = IsWinnerBidderAnAgentAuthorizationForThisPurchaser(horseSaleId, winningBidder, b.purchaser!);
    // Winning bidder always on top
    if (a.purchaser!.id === winningBidder.id && b.purchaser!.id !== winningBidder.id) {
        return -1;
    } else if (a.purchaser!.id !== winningBidder.id && b.purchaser!.id === winningBidder.id) {
        return 1;
    } else {
        // Followed by those sharing the credit/debit with the winning bidder (non-agents)
        if (hasAgentAuthA && !hasAgentAuthB) {
            return 1;
        } else if (!hasAgentAuthA && hasAgentAuthB) {
            return -1;
        } else {
            // Then alphabetical by name
            return ExtractFriendlyName(a.purchaser!).localeCompare(ExtractFriendlyName(b.purchaser!));
        }
    }
};

export const CustomerSortFn = (winningBidder: Customer, horseSaleId: number) => (a: Customer, b: Customer) => {
    const hasAgentAuthA = IsWinnerBidderAnAgentAuthorizationForThisPurchaser(horseSaleId, winningBidder, a);
    const hasAgentAuthB = IsWinnerBidderAnAgentAuthorizationForThisPurchaser(horseSaleId, winningBidder, b);
    // Winning bidder always on top
    if (a.id === winningBidder.id && b.id !== winningBidder.id) {
        return -1;
    } else if (a.id !== winningBidder.id && b.id === winningBidder.id) {
        return 1;
    } else {
        // Followed by those sharing the credit/debit with the winning bidder (non-agents)
        if (hasAgentAuthA && !hasAgentAuthB) {
            return 1;
        } else if (!hasAgentAuthA && hasAgentAuthB) {
            return -1;
        } else {
            // Then alphabetical by name
            return ExtractFriendlyName(a).localeCompare(ExtractFriendlyName(b));
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/checkout/CommonTableSorting.ts